import React from 'react';
import { BetDetails } from '../../../models/MyBetModel.tsx';
import { capitalize, formatNumbers, formatTimestamp, formatWithSign, getBetMatchupLabel, getBetPrimaryName, getPendingMarketSubLabel } from '../.././../helpers/functions.tsx';
import { Timestamp } from 'firebase/firestore';
import { IoCloseSharp } from 'react-icons/io5';
import { Users } from '../../../models/User.tsx';
import { MlbPitchersDetailRow } from '../../shared/MlbPitchersDetailRow.tsx';
import BetLogo from '../../player/modals/BetLogo.tsx';

export const BetDetailsBox = ({ bet, onBetSelected, currentUser }: { bet: BetDetails; onBetSelected?: (bet: BetDetails) => void, currentUser: Users | null }) => {
    if (!currentUser) {
        throw new Error("User not authenticated");
    }
    return (
        <>
            {(bet.betType === 'Parlay' || bet.betType === 'Teaser') ? (
                <>
                    <tr>
                        <td colSpan={8}>
                            <table className="selections-container-detail mx-auto">
                                <tbody className="player-info-details">
                                    <tr>
                                        <th className="title-table-pending">Ticket# </th>
                                        <td className="body-table-pending">{bet.ticket}
                                            {currentUser.status !== "Read-Only" &&
                                                currentUser.status !== "Disabled" &&
                                                onBetSelected && (
                                                    <IoCloseSharp
                                                        className="icon-delete no-show"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#deletBet"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            onBetSelected?.(bet);
                                                        }}
                                                    />
                                                )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="title-table-pending">Status</th>
                                        <td className="body-table-pending">
                                            {capitalize(bet.betStatus)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="title-table-pending">Risk/Win</th>
                                        <td className="body-table-pending">
                                            ${formatNumbers(bet.bet)} / ${formatNumbers(bet.reward)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="title-table-pending">Accepted (PST)</th>
                                        <td className="body-table-pending">{formatTimestamp(bet.betDate ?? Timestamp.now())}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    {bet.selections?.map((selection: any, index: any) => (
                        <tr key={index}>
                            <td colSpan={8} className='detail'>
                                <div>
                                    <div className='alin-text-pending' >
                                        <BetLogo bet={selection} className="sport-logos-pending" alt="" />
                                        <span className='info-item'>{getBetPrimaryName(selection)}</span>
                                        <span className="bet-format">
                                            {selection.odd?.points != null
                                                ? `${formatWithSign(
                                                    selection.odd.points,
                                                    selection.odd?.selection_line,
                                                    "points"
                                                )} `
                                                : ''
                                            }

                                            {selection.odd?.price != null
                                                ? formatWithSign(selection.odd.price)
                                                : ''
                                            }


                                        </span>&nbsp;
                                    </div>
                                    <table style={{ margin: '0 auto' }}>
                                        <tbody className="player-info-details">
                                            <tr>
                                                <th className="title-table-pending">Ticket#</th>
                                                <td className="body-table-pending">{selection.ticket}</td>
                                            </tr>
                                            <tr>
                                                <th className="title-table-pending">Status</th>
                                                <td className="body-table-pending">
                                                    {capitalize(
                                                        selection.grader?.result ?? selection.betStatus
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="title-table-pending">Game</th>
                                                <td className="body-table-pending">
                                                    {getBetMatchupLabel(selection)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="title-table-pending">Sport</th>
                                                <td className="body-table-pending">{selection.sport}</td>
                                            </tr>
                                            <tr>
                                                <th className="title-table-pending">Selection</th>
                                                <td className="body-table-pending">
                                                    {selection.odd.market} - {selection.betName}
                                                </td>
                                            </tr>
                                            <MlbPitchersDetailRow pitchers={selection.pitchers} />
                                            <tr>
                                                <th className="title-table-pending">Scheduled (PST)</th>
                                                <td className="body-table-pending">
                                                    {formatTimestamp(selection.gameDate)}
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    ))}
                </>
            ) : (
                <tr>
                    <td colSpan={8} className='detail'>
                        <table style={{ margin: '0 auto' }}>
                            <tbody className="player-info-details">
                                <tr>
                                    <th className="title-table-pending">Ticket#</th>
                                    <td className="body-table-pending">{bet.ticket}
                                        {currentUser.status !== "Read-Only" &&
                                            currentUser.status !== "Disabled" &&
                                            onBetSelected && (
                                                <IoCloseSharp style={{
                                                    fontSize: "18px",
                                                    strokeWidth: "30px",
                                                }}
                                                    className="icon-delete no-show"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#deletBet"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onBetSelected?.(bet);
                                                    }}
                                                />
                                            )}


                                    </td>
                                </tr>
                                <tr>
                                    <th scope='row' className='title-table-pending'>Status</th>
                                    <td className='body-table-pending'>  {capitalize(bet.betStatus)}</td>
                                </tr>
                                <tr>
                                    <th scope='row' className='title-table-pending'>Game</th>
                                    <td className='body-table-pending'> {getBetMatchupLabel(bet)}</td>
                                </tr>
                                <tr>
                                    <th scope='row' className='title-table-pending'>Sport</th>
                                    <td className='body-table-pending'>{bet.sport}</td>
                                </tr>
                                <tr>
                                    <th scope='row' className='title-table-pending'>Risk/Win</th>
                                    <td className='body-table-pending'>${formatNumbers(bet.bet)} / ${formatNumbers(bet.reward)}</td>
                                </tr>
                                <tr>
                                    <th scope='row' className='title-table-pending'>Selection</th>
                                    <td className='body-table-pending'>
                                        {getPendingMarketSubLabel(bet)
                                            || <>{bet.odd?.market} - {bet.odd?.name} / {bet.odd?.price}</>}
                                    </td>
                                </tr>
                                <MlbPitchersDetailRow pitchers={bet.pitchers} />
                                <tr>
                                    <th scope='row' className='title-table-pending'>Scheduled (PST)</th>
                                    <td className='body-table-pending'>{formatTimestamp(bet.gameDate ?? Timestamp.now())}</td>
                                </tr>
                                <tr>
                                    <th scope='row' className='title-table-pending'>Accepted (PST)</th>
                                    <td className='body-table-pending'>{formatTimestamp(bet.betDate ?? Timestamp.now())}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}
        </>
    );
};



